<template>
  <div :class="['steps', 'children' + steps.length]">
    <div :class="['step', $index === (step - 1) ? 'active': '', $index < (step - 1) ? 'finished' : '', item.state]"
      v-for="(item, $index) in steps" :key="$index">
        <i class="arrow" v-show="$index !== 0"></i>
        <i :class="['icon', item.key]"></i>
        <p class="text">{{item.title}}</p>
        <p class="sub-text">{{item.date}}</p>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    step: {
      type: Number,
      required: true,
    },
    steps: {
      required: true,
      validator: (value) => {
        if (value && value.length) {
          var flag = true
          value.forEach((element) => {
            if (!element.key || !element.title) {
              flag = false
            }
          })
          return flag
          // return true
        } else {
          return false
        }
      },
    },
  },
}
</script>

<style lang="less" scoped>
.steps {
  width: 1200px;
  box-sizing: border-box;
  height: 100px;
  position: relative;
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 0 22px;
  margin-bottom: 20px;
  .step {
    margin-left: 150px;
    width: 120px;
    color: #cccfd1;
    font-size: 16px;
    position: relative;
    text-align: center;
    padding-top: 10px;
    &:first-child {
      margin-left: 0;
    }
    // &::before {
    //   content: ' ';
    //   position: absolute;
    //   width: 0;
    //   height: 0;
    //   left: 82px;
    //   bottom: 0;
    //   border-style: solid;
    //   border-width: 0 8px 8px 8px;
    //   border-color: transparent transparent #ffffff transparent;
    // }
    &.active {
      color: #45484D;
      .icon {
        background-color: #13ce66;
      }
    }
    &.active.failure {
      color: #45484D;
      .icon {
        background-color: #fd4b4f;
      }
    }
    &.finished {
      color: #43484d;
    }
    .arrow {
      position: absolute;
      display: block;
      background: url('../../assets/steps/arrow.png') no-repeat right;
      width: 125px;
      height: 14px;
      top: 40px;
      left:-140px;
    }
    .text {
      margin: 0;
    }
    .sub-text {
      margin: 0;
      font-size: 12px;
    }
  }
  &.children2 .arrow{
    left: -146px;
  }
  &.children3 .arrow{
    left: -146px;
  }
  &.children4 .arrow{
    left: -146px;
  }
  &.children5 .arrow{
    left: -146px;
  }
}
.icon {
  display: inline-block;
  border-radius: 50%;
  width: 42px;
  height: 42px;
  background-repeat: no-repeat;
  background-position: center;
  // background-size: 50%;
  &.draft {
    background-image: url('../../assets/steps/draft.png');
  }
  &.finished {
    background-image: url('../../assets/steps/finished.png');
  }
  &.needConfirmation {
    background-image: url('../../assets/steps/needConfirmation.png');
  }
  &.pay {
    background-image: url('../../assets/steps/pay.png');
  }
  &.qc {
    background-image: url('../../assets/steps/qc.png');
  }
  &.receiving {
    background-image: url('../../assets/steps/receiving.png');
  }
  &.repair {
    background-image: url('../../assets/steps/repair.png');
  }
  &.review {
    background-image: url('../../assets/steps/review.png');
  }
  &.shipped {
    background-image: url('../../assets/steps/shipped.png');
  }
}
.active .icon {
  &.fail {
    background-image: url('../../assets/steps/cancel_active.png');
  }
  &.finished {
    background-image: url('../../assets/steps/finished_active.png');
  }
  &.needPay {
    background-image: url('../../assets/steps/needPay_active.png');
  }
  &.pay {
    background-image: url('../../assets/steps/pay_active.png');
  }
  &.draft {
    background-image: url('../../assets/steps/draft_active.png');
  }
  &.receiving {
    background-image: url('../../assets/steps/receiving_active.png');
  }
  &.qc {
    background-image: url('../../assets/steps/qc_active.png');
  }
  &.repair {
    background-image: url('../../assets/steps/repair_active.png');
  }
  &.review {
    background-image: url('../../assets/steps/review_active.png');
  }
  &.shipped {
    background-image: url('../../assets/steps/shipped_active.png');
  }
  &.cancelled {
    background-image: url('../../assets/steps/cancelled_active.png');
  }
}
.finished .icon {
  &.commit {
    background-image: url('../../assets/steps/commit_finished.png');
  }
  &.needConfirmation {
    background-image: url('../../assets/steps/needConfirmation_finished.png');
  }
  &.needPay {
    background-image: url('../../assets/steps/needPay_finished.png');
  }
  &.qc {
    background-image: url('../../assets/steps/qc_finished.png');
  }
  &.draft {
    background-image: url('../../assets/steps/draft_finished.png');
  }
  &.receiving {
    background-image: url('../../assets/steps/receiving_finished.png');
  }
  &.repair {
    background-image: url('../../assets/steps/repair_finished.png');
  }
  &.review {
    background-image: url('../../assets/steps/review_finished.png');
  }
  &.shipped {
    background-image: url('../../assets/steps/shipped_finished.png');
  }
}
</style>



// WEBPACK FOOTER //
// StepsBar.vue?ac2e7d58